export enum HttpMethod {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    DELETE = 'DELETE',
}

export enum BodyType {
    Json = 'Json',
    FormData = 'FormData',
}

// Базовый интерфейс для ответа API
export interface ApiResponse {
    message?: string;
    [key: string]: unknown;
}

export interface ApiError extends Error {
    status?: number;
}

function apiError(status: number, message: string): ApiError {
    const error: ApiError = new Error(message);
    error.status = status;
    return error;
}

function isAuthRequest(url: string): boolean {
    return url.startsWith('/api/auth/');
}

function returnToSignIn(): void {
    window.location.reload();
}

// Обобщенная функция для отправки запросов с типизированным возвращаемым значением
export async function sendRequest<T = ApiResponse>(
    url: string,
    method: HttpMethod = HttpMethod.GET,
    body: object | FormData | null = null,
    bodyType: BodyType | undefined = undefined,
    headers: Record<string, string> = {}): Promise<T> {

    let bodyToSend: BodyInit | undefined = undefined;
    const allHeaders = {...headers};
    if (body && bodyType === BodyType.Json) {
        bodyToSend = JSON.stringify(body)
        allHeaders['Content-Type'] = 'application/json'
    }
    if (body && bodyType === BodyType.FormData) {
        bodyToSend = body as FormData;
    }
    if (body && bodyType === undefined){
        throw new Error('bodyType must be specified');
    }

    try {
        const response = await fetch(url, {
            method,
            body: bodyToSend,
            headers: allHeaders,
            credentials: 'same-origin'
        })

        if (response.status === 401 && !isAuthRequest(url)) {
            returnToSignIn();
        }

        const contentType = response.headers.get('Content-Type');
        if (contentType !== null && contentType !== undefined && contentType.includes('json')) {
            const data = await response.json() as T;

            if (!response.ok) {
                const errorData = data as unknown as ApiResponse;
                const errorMessage = errorData.message !== undefined && errorData.message !== null ? errorData.message : 'Unknown error';
                throw apiError(response.status, errorMessage);
            }

            return data;
        }

        if (!response.ok) {
            throw apiError(response.status, 'Request failed')
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`Request failed for ${url}:`, error);
        throw error;
    }

    // Если контент не JSON, возвращаем пустой объект
    return {} as T;
}
